module.exports = __webpack_public_path__ + "img/symbol_7.e75d1fd8.png";